import { Cluster, clusterApiUrl } from '@solana/web3.js';

export type ExtendedCluster = Cluster | 'civicnet' | 'localnet';

const solanaMainnetEndpoint =
  process.env.REACT_APP_SOLANA_MAINNET_RPC && process.env.REACT_APP_SOLANA_MAINNET_RPC?.trim() !== ''
    ? process.env.REACT_APP_SOLANA_MAINNET_RPC
    : clusterApiUrl('mainnet-beta');

export const clusterEndpoint = (cluster: ExtendedCluster): string => {
  switch (cluster) {
    case 'mainnet-beta':
      return solanaMainnetEndpoint;
    case 'civicnet':
      return 'https://d3ab7dlfud2b5u.cloudfront.net';
    case 'localnet':
      return 'http://localhost:8899';
    default: {
      return clusterApiUrl(cluster);
    }
  }
};
